import React from 'react';
import { Tables, StatusBar } from '@deeptrue-frontend/ui';
import { ProjectStatus, TRANSLATED_STATUSES } from 'consts/statuses';
import { useFormatMessage } from 'components/IntlProvider';
import GroupIcon from '@material-ui/icons/Group';
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import Tooltip from '@material-ui/core/Tooltip';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { GroupType } from 'pages/OrganizationAdmin/types';
import { Pill } from '../Users/User';

const { TableRow, TableCell } = Tables;

interface Props extends RouteComponentProps {
  name: string;
  productName: string | null;
  status: number;
  id: number;
  sharedGroups: GroupType[];
}

const Project = ({
  name,
  productName,
  status,
  history,
  id,
  sharedGroups,
}: Props) => {
  const t = useFormatMessage();

  return (
    <TableRow>
      <TableCell height="2rem" padding="0.5rem">
        {name}
      </TableCell>
      <TableCell height="2rem" padding="0.5rem">
        {productName}
      </TableCell>
      <TableCell height="2rem" padding="0.5rem">
        {sharedGroups.map((group) => {
          return <Pill key={group.name}>{group.name}</Pill>;
        })}
      </TableCell>
      <TableCell height="2rem" padding="0.5rem" width="180px">
        <StatusBar
          status={{
            value: ProjectStatus[status],
            text: TRANSLATED_STATUSES[status.toString()].statusText(t),
          }}
        />
      </TableCell>
      <TableCell height="2rem" padding="0.5rem">
        <Tooltip title={t('organization.users', 'Users')}>
          <GroupIcon
            style={{ cursor: 'pointer', margin: '0 2px' }}
            onClick={() =>
              history.push(`/organization/projects/${id}/shared?tab=users`)
            }
          />
        </Tooltip>
        <Tooltip title={t('organization.groups', 'Groups')}>
          <RecentActorsIcon
            style={{ cursor: 'pointer', margin: '0 2px' }}
            onClick={() =>
              history.push(`/organization/projects/${id}/shared?tab=projects`)
            }
          />
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default withRouter(Project);
